import type { RendererProps } from "../core/element-registry"
import { useRenderContext } from "../core/render-context"
import { ElementRenderer } from "./element-renderer"
import { cn } from "../lib/utils"

export function PaginationRenderer({ element }: RendererProps) {
  const { resolveSymbol, dispatchEvent } = useRenderContext()

  const items = element.children ?? []

  return (
    <nav
      className={cn("flex items-center justify-center gap-1", element.className)}
      data-testid={`pagination-${element.id}`}
      aria-label="Pagination"
    >
      {items.map((child) => (
        <span key={child.id}>
          {child.type === "button" ? (
            <button
              type="button"
              className={cn(
                "inline-flex items-center justify-center rounded-md px-3 py-2 text-sm font-medium transition-colors border",
                child.variant === "default"
                  ? "bg-primary text-primary-foreground border-primary"
                  : "bg-background text-foreground border-border hover:bg-accent hover:text-accent-foreground"
              )}
              onClick={() => dispatchEvent(child.id, "tap", { value: child.text ?? child.id })}
              aria-label={child.ariaLabel}
            >
              {child.text ? String(resolveSymbol(child.text) ?? "") : ""}
            </button>
          ) : (
            <ElementRenderer element={child} />
          )}
        </span>
      ))}
    </nav>
  )
}
